// iter 539: the upload page checks files before sending, with the same limits the server enforces.
export const MAX_FILES = 20;
export const MAX_FILE_MB = 20;
export const MAX_TOTAL_MB = 60;
const MB = 1024 * 1024;

export const ALLOWED_EXTENSIONS = ["pdf", "jpg", "jpeg", "png", "webp", "heic", "heif", "bmp", "tif", "tiff", "docx"];
export const ACCEPT_ATTR = ALLOWED_EXTENSIONS.map((e) => `.${e}`).join(",");

export const MSG_TYPE = "This type of file can't be uploaded here. Please send a PDF, a photo or a Word (.docx) file.";
export const MSG_EMPTY = "This file is empty. Please check it opens on your device and choose it again.";
export const MSG_TOO_BIG = `This file is over ${MAX_FILE_MB} MB. Please send a smaller copy, or email it to contact@clinicalminds.net.`;
export const MSG_DUPLICATE = "This file is already in the list.";
export const MSG_TOO_MANY = `Please upload up to ${MAX_FILES} files at a time.`;
export const MSG_TOTAL = `These files add up to more than ${MAX_TOTAL_MB} MB. Please upload them in smaller groups.`;

export function extOf(name) {
  const base = String(name || "").split(/[\\/]/).pop();
  return base.includes(".") ? base.split(".").pop().toLowerCase() : "";
}

export function fileProblem(file) {
  if (!ALLOWED_EXTENSIONS.includes(extOf(file.name))) return MSG_TYPE;
  if (!file.size) return MSG_EMPTY;
  if (file.size > MAX_FILE_MB * MB) return MSG_TOO_BIG;
  return null;
}

const keyOf = (f) => `${f.name}|${f.size}`;

// Adds newly chosen files to the list. Returns { files, refused: [{ name, reason }] }.
export function addFiles(current, chosen) {
  const files = [...current];
  const refused = [];
  const seen = new Set(files.map(keyOf));
  let total = files.reduce((n, f) => n + (f.size || 0), 0);
  for (const f of Array.from(chosen || [])) {
    const why = fileProblem(f);
    if (why) { refused.push({ name: f.name, reason: why }); continue; }
    if (seen.has(keyOf(f))) { refused.push({ name: f.name, reason: MSG_DUPLICATE }); continue; }
    if (files.length >= MAX_FILES) { refused.push({ name: f.name, reason: MSG_TOO_MANY }); continue; }
    if (total + f.size > MAX_TOTAL_MB * MB) { refused.push({ name: f.name, reason: MSG_TOTAL }); continue; }
    files.push(f);
    seen.add(keyOf(f));
    total += f.size;
  }
  return { files, refused };
}

// The message to show when the server refuses the whole upload (never a technical error).
export function serverMessage(error) {
  const data = error?.response?.data || {};
  if (data.message || data.error) return data.message || data.error;
  if (error?.response?.status === 413) return MSG_TOTAL;
  return "Sorry, your files weren't saved. Please check your internet connection and try again, or email them to contact@clinicalminds.net.";
}

// Which of the chosen files failed, matched back by position (the server answers in the order the files were sent).
export function failedFiles(sent, results) {
  return (results || []).map((r, i) => (r && r.ok === false ? sent[i] : null)).filter(Boolean);
}
